import { cap } from '../State'
import { translations } from '../translations'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

/**
 * L'etichetta del badge di scenario, dalla **descrizione pubblica** che l'API
 * allega a conversazioni e righe di lista (docs/nora/09 §3).
 *
 * Il server manda campi strutturati e non una frase: l'etichetta si compone qui, perché è
 * il client a sapere la lingua. Nessun campo tecnico della connessione arriva fin qui —
 * classificazione, endpoint e credenziali restano nel pannello e nel server.
 *
 * Restituisce `null` quando la conversazione non ha un profilo: sul percorso storico non
 * si mostra nessun badge nuovo.
 */
const FLUSSI = {
  offer_selection: 'agScenarioOfferSelection',
  case_submission: 'agScenarioCaseSubmission',
  booking: 'agScenarioBooking'
}

const MODI = {
  simulate: 'agScenarioModoSimulate',
  execute: 'agScenarioModoExecute',
  deny: 'agScenarioModoDeny'
}

export const getScenarioBadge = (conv) => {
  const scenario = conv?.scenario
  if (!scenario?.workflowId) return null
  const chiaveFlusso = FLUSSI[scenario.workflowId]
  if (!chiaveFlusso) return null

  const pezzi = [t[chiaveFlusso]]
  const chiaveModo = scenario.mutationMode ? MODI[scenario.mutationMode] : null
  if (chiaveModo) pezzi.push(t[chiaveModo])
  if (scenario.readSource === 'fixture') pezzi.push(t.agScenarioDatiFixture)

  return {
    label: t[chiaveFlusso],
    // `execute` è l'unico che scrive davvero sul mid-office: è l'informazione che
    // l'operatore deve vedere senza doverci passare sopra col mouse.
    variant: scenario.mutationMode === 'execute' ? 'warning' : 'neutral',
    title: `${t.agScenario}: ${pezzi.join(' · ')}`
  }
}
